<template>
  <div>
    <label class="switch" >
      <input type="checkbox" :checked="isHavingLiveChat" @click="onToggle"/>
      <span class="slider round"></span>
    </label>
    <span class="toggle-label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    isHavingLiveChat: {
      type: Boolean,
      default: false,
    },
    onToggle: {
      type: Function,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 23px;
  margin-bottom: 0;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  &::before {
    position: absolute;
    content: "";
    height: 17px;
    width: 17px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
}

input {
  &:checked {
    + .slider {
      background-color: #032a56;
      &::before {
        -webkit-transform: translateX(17px);
        -ms-transform: translateX(17px);
        transform: translateX(17px);
      }
    }
  }
  &:focus {
    + .slider {
      box-shadow: 0 0 1px #032a56;
    }
  }
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}

.toggle-label {
  position: relative;
  top: 3px;
  left: 0.5rem;
}
</style>
